export const EXCHANGE_PATH = '/api/auth-service/v1/jwt/exchange';

const CONFIG_BY_ENV = {
  devops: {
    authCookieName: 'x-bennie-auth-token-devops',
    signalCookieName: 'x-bennie-auth-token-devops-signal',
  },
  stage: {
    authCookieName: 'x-bennie-auth-token-stage',
    signalCookieName: 'x-bennie-auth-token-stage-signal',
  },
  production: {
    authCookieName: 'x-bennie-auth-token-prod',
    signalCookieName: 'x-bennie-auth-token-prod-signal',
  },
};

let activeConfig = null;

/**
 * Resolves the Bennie environment from bennie-web's runtime ENVIRONMENT value.
 * Local dev assumes devops since the gateway it talks to is typically devops.
 */
export function resolveBennieEnv(environment) {
  switch (String(environment || '').toLowerCase()) {
    case 'production':
      return 'production';
    case 'staging':
    case 'stage':
      return 'stage';
    case 'local':
    case 'devops':
      return 'devops';
    default:
      return undefined;
  }
}

/**
 * Initializes the Bennie session config for the current environment.
 * Must be called once at app startup before any session operations.
 */
export function initBennieSessionConfig(environment) {
  const config = CONFIG_BY_ENV[environment];
  activeConfig = config || null;
  return activeConfig;
}

/**
 * Returns the active Bennie session config.
 * Throws if `initBennieSessionConfig` has not been called.
 */
export function getBennieSessionConfig() {
  if (!activeConfig) {
    throw new Error(
      'Bennie session config not initialized. Call initBennieSessionConfig(environment) at app startup.',
    );
  }

  return activeConfig;
}

/**
 * Returns the active config, or null if not yet initialized.
 * Prefer this over try/catch around `getBennieSessionConfig` in optional contexts.
 */
export function getBennieSessionConfigOrNull() {
  return activeConfig;
}
